import React, { Component, createRef } from "react";
import { FormattedMessage } from "react-intl";
import { connect, type ConnectedProps } from "react-redux";

import remoteLog from "../../../common/logging";
import { getLastCorrection } from "../../../common/patient";
import { deployedRussia } from "../../../common/utils";
import type { RootState } from "../../../store";
import FormatNumber from "../../common/FormatNumber";
import { Portlet, PortletTerm, PortletTitle } from "../../ui/portlet";

const mapStateToProps = (state: RootState) => {
  return {
    patient: state.patient,
  };
};

type PatientPaymentProps = PropsFromRedux;

type PatientPaymentState = {
  paymentState: boolean;
};

class PatientPayment extends Component<PatientPaymentProps, PatientPaymentState> {
  toggleDivRef = createRef<HTMLDivElement>();

  constructor(props: PatientPaymentProps) {
    super(props);
    this.togglePayment = this.togglePayment.bind(this);
    this.state = {
      paymentState: false,
    };
  }

  componentDidCatch(e: Error) {
    remoteLog(e, "patient_payment");
  }

  togglePayment() {
    this.setState({ paymentState: !this.state.paymentState });
    $(this.toggleDivRef.current).slideToggle();
  }

  render() {
    const currentPayments = this.props.patient.total_payments;
    const lastCorrection = getLastCorrection(this.props.patient);

    return (
      <Portlet id="payment-info-side-block">
        <PortletTitle as="h2" iconClassName="icon-wallet" id="payment-info-side-block-name">
          <FormattedMessage id="pat.block.payment.header" />
        </PortletTitle>

        <a id="payment-info-side-show-button" onClick={this.togglePayment}>
          <FormattedMessage
            id={this.state.paymentState ? "general.payment.close" : "general.payment.show"}
          />
        </a>

        <div
          className="portlet-body"
          ref={this.toggleDivRef}
          style={{ display: "none" }}
          id="payment-info-side-block-body"
        >
          <PortletTerm id="payment-status-side-block-label">
            <FormattedMessage id="pat.block.payment.status" />
          </PortletTerm>

          <p id="payment-status-side-block-value">
            {lastCorrection.payment_status ? (
              <FormattedMessage id={lastCorrection.payment_status} />
            ) : null}
          </p>

          {deployedRussia() ? (
            <div>
              <PortletTerm id="paid-info-side-block-label">
                <FormattedMessage id="pat.block.payment.received" />
              </PortletTerm>
              <p id="paid-info-side-block-value">
                <FormatNumber value={currentPayments.paid} />{" "}
                <FormattedMessage id="pat.block.payment.currency" />
              </p>

              <PortletTerm id="payment-due-side-block-label">
                <strong>
                  <FormattedMessage id="pat.block.payment.total" />
                </strong>
              </PortletTerm>
              <p id="payment-due-side-block-value">
                <FormatNumber value={currentPayments.total} />{" "}
                <FormattedMessage id="pat.block.payment.currency" />
              </p>
            </div>
          ) : (
            <div>
              <PortletTerm id="paid-info-side-block-label">
                <FormattedMessage id="pat.block.payment.currency.usa" />{" "}
                <FormattedMessage id="pat.block.payment.received" />{" "}
              </PortletTerm>
              <p id="paid-info-side-block-value">
                <FormattedMessage id="pat.block.payment.currency.usa" />{" "}
                <FormatNumber value={currentPayments.paid} />
              </p>

              <PortletTerm id="payment-due-side-block-label">
                <FormattedMessage id="pat.block.payment.currency.usa" />{" "}
                <FormattedMessage id="pat.block.payment.total" />
              </PortletTerm>
              <p id="payment-due-side-block-value">
                <FormattedMessage id="pat.block.payment.currency.usa" />{" "}
                <FormatNumber value={currentPayments.total} />
              </p>
            </div>
          )}
        </div>
      </Portlet>
    );
  }
}

const connector = connect(mapStateToProps);
type PropsFromRedux = ConnectedProps<typeof connector>;
export default connector(PatientPayment);
